import VendedorTelefoneService from "@/services/VendedorTelefoneService";

export const vendedorTelefone = {
  namespaced: true,
  state: {
    vendedorTelefone: {},
  },
  actions: {
    getVendedorTelefone({ commit }, payload) {
      return VendedorTelefoneService.GetVendedorTelefone(payload).then(
        (vendedorTelefone) => {
          return Promise.resolve(vendedorTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVendedorTelefone({ commit }, payload) {
      return VendedorTelefoneService.PostVendedorTelefone(payload).then(
        (vendedorTelefone) => {
          return Promise.resolve(vendedorTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVendedorTelefone({ commit }, payload) {
      return VendedorTelefoneService.PutVendedorTelefone(payload).then(
        (vendedorTelefone) => {
          return Promise.resolve(vendedorTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVendedorTelefone({ commit }, payload) {
      return VendedorTelefoneService.DeleteVendedorTelefone(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVendedorTelefoneOData({ commit }, payload) {
      return VendedorTelefoneService.GetVendedorTelefoneOData(payload).then(
        (vendedorTelefone) => {
          return Promise.resolve(vendedorTelefone);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default vendedorTelefone;
